/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCarbon: {
  name: 'carbon';
  data: string;
} = {
  name: 'carbon',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.09 1.508a.5.5 0 0 0-.564.334l-2 5.997a.5.5 0 0 0-.005.019l-.004.012a.498.498 0 0 0 .037.355l2.999 5.999A.5.5 0 0 0 4 14.5h9a.5.5 0 0 0 .48-.363l2-6.996a.498.498 0 0 0-.007-.304l-.999-2.995a.5.5 0 0 0-.385-.334l-11-2ZM13.62 4.44l.76 2.283L7.966 9.47 1.64 7.663l1.698-5.094L13.62 4.44Zm-4.644 5.687 3.773 2.934 1.481-5.186-5.254 2.252Zm2.71 3.374-3.917-3.046-5.813-1.661L4.309 13.5h7.377Z" fill="currentColor"/></svg>`,
};
